import React from 'react';
import BlogCard from './BlogCard';
import { blogPosts } from '../../content/blog';
import useReveal from '../../hooks/useReveal';
import './BlogListSection.css';

/** Full blog index for the /blog page: featured newest post + grid. */
const BlogListSection = () => {
  const [featured, ...rest] = blogPosts;
  const gridRef = useReveal({ threshold: 0.05 });

  return (
    <section className="blog-list-section">
      <header className="blog-list-header">
        <span className="blog-list-kicker">Blog</span>
        <h1>Einblicke aus der Praxis</h1>
        <p>
          Fachbeiträge rund um Webentwicklung, App-Entwicklung, UI/UX Design und
          Online-Marketing – aus unserer täglichen Arbeit für Industrie und Mittelstand.
        </p>
      </header>

      <div className="blog-list-content" ref={gridRef}>
        {featured && (
          <div className="blog-list-item" style={{ '--card-delay': '0ms' }}>
            <BlogCard post={featured} featured />
          </div>
        )}

        <div className="blog-list-grid">
          {rest.map((post, index) => (
            <div
              key={post.slug}
              className="blog-list-item"
              style={{ '--card-delay': `${(index + 1) * 110}ms` }}
            >
              <BlogCard post={post} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogListSection;
